module.exports = __webpack_public_path__ + "assets/img/immediatelyRob.b632b296.png";